<template>
  <div id="Manage">
    <!-- 基础设置 旅游区域 分类-->

    <!-- Dialog 对话框 -->
    <el-dialog :title="dialogFonfig.openType === 'add' ? dialogFonfig.addName : dialogFonfig.editName"
               :visible.sync="dialogFonfig.isShowDialogVisible"
               @close="clickCancelData">
      <CommonForm :form="openForm"
                  :formLabel="openFormLabel"></CommonForm>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="clickCancelData">取 消</el-button>
        <el-button type="primary"
                   @click="clickSubmitData(dialogFonfig.openType, openForm)">确 定</el-button>
      </div>
    </el-dialog>

    <CommonManageMain>
      <template v-slot:header>
        <div>
          <el-button type="primary"
                     size="small"
                     @click="clickAddData"
                     icon="el-icon-circle-plus-outline">增加旅游区域</el-button>
          <!-- <el-button
            type="danger"
            size="small"
            @click="clickDelUser"
            icon="el-icon-delete"
            >删除</el-button
          > -->
        </div>

        <CommonForm :form="searchForm"
                    :formLabel="searchformLabel"
                    inline>
          <el-button type="primary"
                     @click="searchKeyword(searchForm)">搜索</el-button>
          <el-button type="text"
                     @click="resetFilter(searchForm)">重置筛选条件</el-button>
        </CommonForm>
      </template>

      <!-- 表格内容框 -->
      <template v-slot:content>
        <CommonTable :tableData="tableData"
                     :tableLabel="tableLabel"
                     :tableConfig="tableConfig"
                     @getPage="getPage">
          <el-table-column label="操作"
                           width="180">
            <template slot-scope="scope">
              <el-tooltip :enterable="false"
                          class="item"
                          effect="dark"
                          content="添加子分类"
                          placement="top">
                <span @click='addSubcategory(scope.$index, scope.row)'>添加子分类</span>
              </el-tooltip>
              <el-tooltip :enterable="false"
                          class="item"
                          effect="dark"
                          content="编辑"
                          placement="top">
                <span @click="clickEditData(scope.$index, scope.row)">编辑</span>
              </el-tooltip>
              <el-tooltip :enterable="false"
                          class="item"
                          effect="dark"
                          content="删除"
                          placement="top">
                <span @click='clickDeleteData(scope.$index, scope.row)'>删除</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </CommonTable>
      </template>
    </CommonManageMain>
  </div>
</template>

<script>
import {
  getTourAreaList, metTourAreaList
} from 'api/basis.js'
import CommonForm from 'components/CommonForm.vue'
import CommonTable from 'components/CommonTable.vue'
import CommonManageMain from 'components/CommonManageMain.vue'
export default {
  components: {
    CommonForm,
    CommonTable,
    CommonManageMain
  },
  data () {
    return {

      // 对话框 Dialog 基础数据
      dialogFonfig: {
        openType: 'add',
        addName: '新增旅游区域',
        editName: '编辑旅游区域',
        isShowDialogVisible: false
      },

      // form表单 基础数据
      openForm: {
        name: "",
        initial: "",
        spell: "",
        pid: '',
        is_hot: "",
        img: "",
        description: "",
        is_scenery: '',
        status: "",
        sort: "",
      },
      openFormLabel: [
        {
          model: 'name',
          label: '区域名称'
        },
        {
          model: 'initial',
          label: '区域首字母'
        },
        {
          model: 'spell',
          label: '区域首字母拼写'
        },
        {
          model: 'description',
          label: '区域描述'
        },
        {
          model: 'img',
          label: '旅游图片',
          type: 'upload',
          maxSize: 2048,
          imgHeight: '1280',
          imgWidth: '808',
        },
        {
          model: 'pid',
          label: '父级ID',
        },
        {
          model: 'is_scenery',
          label: '是否景区',
          type: 'select',
          options: [
            { value: 0, label: '否' },
            { value: 1, label: '是' },
          ]
        },
        {
          model: 'is_hot',
          label: '热门推荐',
          type: 'select',
          options: [
            { value: 0, label: '禁用' },
            { value: 1, label: '启用' },
          ]
        },
        {
          model: 'sort',
          label: '排序'
        },
        {
          model: 'status',
          label: '状态',
          type: 'select',
          options: [
            { value: 0, label: '禁用' },
            { value: 1, label: '启用' },
          ]
        }
      ],

      // form表单 搜索数据
      searchForm: {
        keyword: ''
      },
      searchformLabel: [
        {
          model: 'keyword',
          label: '分类名称',
          labelOFF: true

        }
      ],
      // table 表格 基础数据
      tableData: [],
      tableLabel: [
        {
          prop: 'name',
          label: '旅游区域名称',
          width: '300px'
        },
        {
          prop: 'description',
          label: '区域描述'
        },
        {
          prop: 'pid',
          label: '父级ID'
        },
        {
          prop: 'img',
          label: '图片路径',
          type: 'logo'
        },
        {
          prop: 'is_hot',
          label: '热门',
          type: 'yesOrNo'
        },
        {
          prop: 'state',
          label: '状态',
          type: 'stateNotouch'
        },
        {
          prop: 'sort',
          label: '排序',
        }
      ],
      tableConfig: {
        isShowLoading: true,
        // 改造状态列显示效果 el-switch

        page: 1,
        total: 30,
        // 加载状态
        loading: false,
        // 显示选择多行数据
        selection: false
      },

      // 全部-数据
      brandAllDataObj: {},
      // 级联选择器 数据
      cascaderDataArr: [],
      // 格式处理-列表数据
      barndFormatDealListData: []
    }
  },

  mounted () {
    this.getTourAreaList()
  },

  activated () {

  },
  watch: {
    brandAllDataObj: function () {
      this.tableData = this.dataFormatDeal(
        this.brandAllDataObj.list,
        {
          // category_name: 'category_name',
          // category_pic: 'category_pic',
          child: 'children',
          status: 'state',
        }
      )
      // this.cascaderDataArr = this.dataFormatDeal(
      //   this.brandAllDataObj.list,
      //   {
      //     category_name: 'label',
      //     id: 'value',
      //     child: 'children'
      //   },
      //   1
      // )
    }
  },

  methods: {
    // //   获取--旅游区域列表数据
    // getTourAreaList () {
    //   getTourAreaList().then(res => {
    //     const DATA = res.data
    //     console.log(DATA)
    //     if (DATA.code == 200) {
    //       this.$message({
    //         message: DATA.message,
    //         type: 'success'
    //       })
    //       this.brandAllDataObj = DATA.data
    //     }
    //   })
    // },
    //获得下列分类页的页数
    getPage () {
      if (this.searchData) {
        this.searchData.page = this.tableConfig.page
        this.getTourAreaList(this.searchData)
      } else {
        this.getTourAreaList()
      }
    },
    // 获取--旅游区域列表数据
    getTourAreaList (data) {
      if (data) {
        getTourAreaList(data).then(res => {
          console.log(res)
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            this.brandAllDataObj = DATA.data
            this.tableConfig.total = DATA.data.total
          }
        })
      } else {
        getTourAreaList({
          page: this.tableConfig.page,
          page_rows: 10
        }).then(res => {
          console.log(res)
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            this.brandAllDataObj = DATA.data

            this.tableConfig.total = DATA.data.total
            this.tableConfig.loading = false
          }

        })
      }
    },

    // 更新数据  -- 添加-编辑旅游
    metTourAreaList (met, data) {
      metTourAreaList(met, data).then(res => {
        console.log(res)
        const resData = res.data
        if (resData.code == 200) {
          // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
          this.$nextTick().then(() => {
            this.getTourAreaList()
          })
        }
      })
    },

    // 数据格式处理
    dataFormatDeal (arr, keyMap, copyInKeyMap) {
      // global 全局方法处理
      return this.globalDeepCloneData(arr, keyMap, copyInKeyMap)
    },

    // 树形结构数据 查找 value 值
    getParentValues (value, data) {
      // 深度遍历查找
      function dfs (data, value, parents) {
        for (var i = 0; i < data.length; i++) {
          var item = data[i]
          // 找到value 则返回父级 value
          if (item.value === value) return parents
          // children不存在或为空则不递归
          if (!item.children || !item.children.length) continue
          // 往下查找时将当前 value 入栈
          parents.push(item.value)

          if (dfs(item.children, value, parents).length) return parents
          // 深度遍历查找未找到时当前 value 出栈
          parents.pop()
        }
        // 未找到时返回空数组
        return []
      }

      return dfs(data, value, [])
    },

    //= ==================================================
    // 添加数据
    clickAddData () {
      console.log(this.openForm)
      this.dialogFonfig.openType = 'add'
      // this.openForm.parentOptions = this.cascaderDataArr
      this.dialogFonfig.isShowDialogVisible = true

    },
    //添加子分类
    addSubcategory (idx, row) {
      console.log(row)
      this.dialogFonfig.isShowDialogVisible = true
      this.openForm = {
        pid: row.id,
      }
      this.dialogFonfig.openType = 'add'
    },
    // 确定提交数据操作
    clickSubmitData (type, data) {
      // const dStatus = data.status == true ? 1 : 0
      // const dParent_id = data.parent_id.pop()
      // const DATA = data
      // DATA.status = dStatus
      // DATA.parent_id = dParent_id

      // type == 'add' ? this.metTourAreaList('POST', DATA) : this.metTourAreaList('PUT', DATA)
      // this.dialogFonfig.isShowDialogVisible = false

      // setTimeout(this.clickCancelData, 3000)
      if (type == 'add') {
        const DATA = {
          name: data.name,
          initial: data.initial,
          spell: data.spell,
          pid: data.pid,
          is_hot: data.is_hot,
          img: data.img,
          description: data.description,
          is_scenery: data.is_scenery,
          status: data.status,
          sort: data.sort,
        }
        this.metTourAreaList('POST', DATA)
      } else if (type == 'edit') {
        const DATA = {
          id: data.id,
          name: data.name,
          initial: data.initial,
          spell: data.spell,
          pid: data.pid,
          is_hot: data.is_hot,
          img: data.img,
          description: data.description,
          is_scenery: data.is_scenery,
          status: data.status,
          sort: data.sort,
        }
        console.log(DATA)
        this.metTourAreaList('PUT', DATA)
      }
      this.dialogFonfig.isShowDialogVisible = false
      this.openForm = this.$options.data().openForm;
    },
    // 取消提交数据操作
    clickCancelData () {
      this.dialogFonfig.isShowDialogVisible = false
      this.openForm = {
        name: "",
        initial: "",
        spell: "",
        pid: '',
        is_hot: "",
        img: "",
        description: "",
        is_scenery: '',
        status: "",
        sort: "",
      }
      // this.openForm.parentOptions = this.cascaderDataArr
    },
    // 编辑数据
    clickEditData (idx, row) {
      //  openForm: {
      //   category_name: "",
      //   category_pic: "",
      //   parent_id: "",
      //   status: true
      // },

      // 多选框数据
      // const parentIdArr = []
      // if (this.getParentValues(row.parent_id, this.cascaderDataArr).length == 0) {
      //   row.parent_id == 0 ? parentIdArr.push(row.id) : parentIdArr.push(row.parent_id, row.id)
      // } else {
      //   const parentValue = this.getParentValues(row.parent_id, this.cascaderDataArr)
      //   parentIdArr.push(...parentValue, row.parent_id, row.id)
      // }
      console.log(row)
      this.openForm = {
        id: row.id,
        name: row.name,
        initial: row.initial,
        spell: row.spell,
        pid: row.pid,
        is_hot: row.is_hot,
        img: row.img,
        description: row.description,
        is_scenery: row.is_scenery,
        status: row.state,
        sort: row.sort,
      }

      // this.openForm.parentOptions = this.cascaderDataArr
      this.dialogFonfig.isShowDialogVisible = true
      this.dialogFonfig.openType = 'edit'
    },
    // 删除数据
    clickDeleteData (idx, row) {
      const Id = row.id
      this.metTourAreaList('DELETE', { id: Id })
    },
    //根据条件搜索
    searchKeyword (searchForm) {
      const data = {
        search: searchForm.keyword
      }
      this.getTourAreaList(data)
    },
    //重置筛选条件
    resetFilter (searchForm) {

      searchForm.keyword = ''
      this.getTourAreaList()
    }
    // 表格开关操作
    // changeSwitch (row) {
    //   const DATA = {
    //     id: row.id,
    //     category_name: row.name,
    //     category_pic: row.pic,
    //     parent_id: row.parent_id,
    //     status: row.status == true ? 1 : 0,
    //     sort: row.sort,
    //   }

    //   this.metTourAreaList('PUT', DATA)
    // }
  }
}
</script>

<style lang="scss" scoped>
#Manage {
  display: flex;
  display: -webkit-flex;
  // 主轴方向
  flex-direction: column;
  height: 100%;
  .el-transfer {
    text-align: center;
    /deep/ .el-transfer-panel {
      text-align: left;
    }
  }
  /deep/ .el-dialog {
    width: 30%;
  }
  span {
    font-size: 14 px;
    margin-left: 8px;
    color: #0486fe;
    cursor: pointer;
  }
}
</style>
